/**
 * EnumPlanId
 * @export EnumPlanId
 * @enum
 */

enum EnumPlanId {
    Initial = 'b5aa9ef1-6178-4b6b-829a-980633dd6e9b',
    Plus = '70340e34-1f7b-4056-9cc2-89af60724130',
    Advanced = '6da85d49-7166-4f66-92c7-794af4ee5542',
    Premium = '1e953634-6928-442c-b8d2-a86ca302d57d',
}
export default EnumPlanId
